import { makeStyles, Theme, Typography, createStyles } from "@material-ui/core"
import React, { FC } from "react";


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
   
    root: {
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(12),
        width: 800,
        margin: "auto",
    },
    paragraph: {
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(2),
    }
  }),
);

const Refunding: FC = () => {
    const classes = useStyles();

    return <div className={classes.root}>
        <Typography variant="h4">
            Vivani - Refund policy
        </Typography>
        
        <Typography variant="body1" className={classes.paragraph}>
            We're so convinced you'll absolutely love our services, that we're willing to offer a 30 day risk-free money back guarantee. 
            If you are not satisfied with the service for any reason you can get a refund within 30 days of making a purchase. 
            Please keep in mind that even though we offer a full money back guarantee, we will issue a refund only for the unused portion of the service.
        </Typography>


        <Typography variant="h5">
            Contacting us
        </Typography>
        <Typography variant="body1" className={classes.paragraph}>
            If you would like to contact us concerning any matter relating to this Refund Policy, you may send an email to office@meet.rs
        </Typography>

        
        <Typography variant="body1" className={classes.paragraph}>
            This document was last updated on July 1, 2020          
        </Typography>
    </div>;
}

export default Refunding;